import ROUTES from '../assets/routes'

export function isEmbeddedStrategyChartContext(): boolean {
    if (typeof window === 'undefined') return false
    const p = window.location.pathname
    const route = ROUTES.embeddedStrategyChart
    return p === route || p.endsWith(route) || p.startsWith(`${route}/`)
}
